import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const SendWithSelector = ({ selectedSendWith, onSendWithChange, sectionKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const options = [
    { value: 'none', label: 'Send with:' },
    { value: 'hpi', label: 'Send with HPI' },
    { value: 'ros', label: 'Send with ROS' },
    { value: 'assessment_plan', label: 'Send with Assessment & Plan' }
  ];
  
  const selectedOption = options.find(opt => opt.value === selectedSendWith) || options[0];
  
  const handleSendWithChange = (newSendWith) => {
    onSendWithChange(sectionKey, newSendWith);
    setIsOpen(false);
  };
  
  return (
    <div className="relative inline-block ml-2">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="px-2 py-1 text-sm rounded-md bg-white hover:bg-gray-200 text-gray-700 border border-gray-200 transition-colors duration-200 flex items-center gap-1"
      >
        <span>{selectedOption.label}</span>
        <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="absolute z-50 mt-2 min-w-[160px] bg-white border border-gray-200 rounded-md shadow-lg">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSendWithChange(option.value);
              }}
              className={`block w-full text-left px-3 py-2 text-sm hover:bg-gray-100 ${
                selectedSendWith === option.value ? 'bg-gray-50 text-teal-600 font-medium' : 'text-gray-700'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SendWithSelector; 